import { AsyncThunk, createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import { axiosInstance } from '../../shared/api/axios-instance';
import { createQueryParams } from '../../shared/utils/create-query-params/create-query-params.util';
import { Endpoints } from '../../shared/utils/endpoints-file.utils';
import { WebGamesFiltersModel } from './models/web-games-filters.model';

export const getWebGamesTotalCount: AsyncThunk<
  number,
  Partial<WebGamesFiltersModel> | undefined,
  Record<string, unknown>
> = createAsyncThunk('web-game/get-web-games-count', async filters => {
  const queryParams = createQueryParams({
    ...filters,
  });

  const { data }: AxiosResponse<number> = await axiosInstance.get(
    Endpoints.WEB_GAMES_TOTAL_COUNT + queryParams
  );

  return data;
});
